// components/DatePicker.tsx
import { useState } from 'react';
import { Popover, PopoverContent, PopoverTrigger } from '@/components/atoms/Popover';
import CalendarIcon from '@/assets/icons/OrderDetails/eva_calendar-outline.svg?react';

import { format } from 'date-fns';
import { ko } from 'date-fns/locale';
import { Calendar } from '@/components/atoms/Calendar';
import { useMembershipPreviewMode } from '@/components/membership/MembershipContentLock';
import { cn } from '@/utils/tailwind';

interface DatePickerProps {
  date?: Date;
  setDate: (date: Date | undefined) => void;
  disabled?: (date: Date) => boolean;
}

export const DatePicker = ({ date, setDate, disabled }: DatePickerProps) => {
  const [isOpen, setIsOpen] = useState(false);
  const isPreviewMode = useMembershipPreviewMode();

  return (
    <div className="flex items-center gap-2">
      <Popover open={isOpen} onOpenChange={setIsOpen}>
        <PopoverTrigger asChild>
          <button
            className={cn(
              'flex h-[40px] w-[146px] items-center justify-between rounded-[8px] border border-gr-300 p-[12px] text-gr-800 Body5M14',
              isOpen && 'border-point-500',
            )}
          >
            {date ? format(date, 'yyyy/MM/dd', { locale: ko }) : '날짜 선택'}
            <CalendarIcon />
          </button>
        </PopoverTrigger>
        <PopoverContent
          className="w-auto bg-white p-0"
          align="start"
          data-membership-preview-interactive={isPreviewMode ? 'true' : undefined}
        >
          <Calendar
            mode="single"
            selected={date}
            onSelect={setDate}
            disabled={disabled}
            defaultMonth={date}
            initialFocus
            locale={ko}
            formatters={{
              formatCaption: (month) => format(month, 'yyyy.MM', { locale: ko }),
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  );
};
